import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRuntimeCorrelationNavigation = () => {
  const navigate = useNavigate();

  const goToCorrelation = useCallback(
    (correlationId) => {
      const normalized = String(correlationId || '').trim();
      if (!normalized) {
        return;
      }

      navigate(
        `/platform/saas-billing/runtime/search?correlation_id=${encodeURIComponent(normalized)}`
      );
    },
    [navigate]
  );

  return {
    goToCorrelation,
  };
};

export default useRuntimeCorrelationNavigation;